import { doDelete, doGet, doPost, doPut, doRequest } from '../http/httpHelper';

export const listUsers = async () => {
    const resp = await doGet('/users');
    return resp;
};

export const delUser = async (email) => {
    const resp = await doDelete(`/users?email=${encodeURIComponent(email)}`);
    return resp;
};

export const createUser = async (user) => {
    const resp = await doPost(`/users`, user);
    return resp.body;
};

export const editUser = async (user) => {
    const resp = await doPut(`/users`, user);
    return resp.body;
};

export const verifyUser = async (user) => {
    const resp = await doPut(`/users/verify`, user);
    return resp.body;
};

export const signPrivacyTerm = async (user) => {
    const resp = await doPost(`/signPrivacyTerm`, user);
    return resp;
};

export const ping = async () => {
    return await doGet('/ping', false);
};
